export default __webpack_public_path__ + "static/media/greensucess.a827c2fe.png";